import Vue from "vue";
import app from '../main'; // import the instance

import VueMasonry from 'vue-masonry-css';
Vue.use(VueMasonry);

import VueMoment from "vue-moment";
Vue.use( VueMoment );

import Axios from "axios";
import VueAxios from "vue-axios";
Vue.use( VueAxios, Axios );

Vue.axios.interceptors.request.use( config => {
  const token = localStorage.getItem('eleToken');
  Vue.prototype.$Progress.start();

  if (token) {
    config.headers.Authorization = token.indexOf('bearer') !== -1 ? token : 'bearer ' + token;
  };
  return config;
}, error => {
  // console.log(error);
  return Promise.reject( error );
});

Vue.axios.interceptors.response.use(
  response => {
    Vue.prototype.$Progress.finish()
    return response
  },
  error => {
    Vue.prototype.$Progress.finish()
/*
    const { status } = error.response
    if (status == 401) {
      Message.error("Invalid Token. 다시 로그인해주세요.")

      localStorage.removeItem("eleToken")
      router.push("/login")
    }
*/
    return Promise.reject(error)
  }
)



export default {};
